import { RootState } from "shared/config/store"

export const selectSystemFieldsSelector = (state: RootState) => state.search.systemFields

export const selectSearchBoardsSelector = (state: RootState) => state.search.boards

export const selectSearchAssetsSelector = (state: RootState) => state.search.assets

export const selectSearchIsLoadingSelector = (state: RootState) => state.search.isLoading

export const selectSearchErrorSelector = (state: RootState) => state.search.error

export const selectSearchResultsSelector = (state: RootState) => state.search.searchResults

export const selectSearchIsLoadingMenuSelector = (state: RootState) => state.search.isLoadingMenu

export const selectSearchLabelsSelector = (state: RootState) => state.search.labels

export const selectSearchTagsSelector = (state: RootState) => state.search.searchTags

export const selectSearchTagsTypeSelector = (state: RootState) => state.search.searchTagsType

export const selectSearchIsSearchInputActiveSelector = (state: RootState) => state.search.isSearchInputActive

export const selectSearchIsTagMenuVisibleSelector = (state: RootState) => state.search.isTagMenuVisible

export const selectSearchIsSearchPageSelector = (state: RootState) => state.search.isSearchPage

export const selectSearchAiTagsSelector = (state: RootState) => state.search.searchAiTags

export const selectSearchStatusSelector = (state: RootState) => state.search.searchStatus

export const selectSearchPrevStateSearchSelector = (state: RootState) => state.search.prevStateSearch

export const selectSearchResultsAiTagsSelector = (state: RootState) => state.search.resultsSearchAiTags

export const selectSearchInputValueSelector = (state: RootState) => state.search.inputValue

export const selectSearchPrevStateSearchParamsSelector = (state: RootState) => state.search.prevStateSearch

export const selectFoundedTagsSelector = (state: RootState) => state.search.foundedTags

export const selectFoundedAiTagsSelector = (state: RootState) => state.search.foundedAiTags

export const selectFoundedStatusesSelector = (state: RootState) => state.search.foundedStatuses

export const selectSearchSelectedItemsIdsSelector = (state: RootState) => state.search.selectedItemsIds

export const selectFilterTags = (state: RootState) => state.search.filterTags
